import { ThemeProvider } from '@mui/material';
import { CTheme } from 'ui-library';
import { App } from 'src/Containers/App';
import { StylesProvider, createGenerateClassName } from '@mui/styles';
import DebugInspector from 'src/Components/DebugInspector';

export const generateClassName = createGenerateClassName({
  productionPrefix: 'sm',
  seed: 'sm',
});

export function RootApp() {
  return (
    <StylesProvider generateClassName={generateClassName} data-test-id="sales-portal-mfe-src-RootApp-StylesProvider">
      <ThemeProvider theme={CTheme} data-test-id="sales-portal-mfe-src-RootApp-ThemeProvider">
        <App data-test-id="sales-portal-mfe-src-RootApp-App" />
        <DebugInspector />
      </ThemeProvider>
    </StylesProvider>
  );
}

export default RootApp;
